import { faqData } from "@/mocks/siteData";

export default function FAQSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 bg-secondary-100/80 text-secondary-700 text-xs font-medium rounded-full mb-4">
            FAQ
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            Common questions about BaseTao Spreadsheet, answered by our research team.
          </p>
        </div>

        <div className="space-y-4">
          {faqData.map((faq, idx) => (
            <details key={idx} className="group border border-background-200/70 rounded-xl bg-background-50">
              <summary className="flex items-center justify-between px-6 py-5 cursor-pointer list-none">
                <h3 className="font-heading text-base font-semibold text-foreground-900 pr-4">
                  {faq.question}
                </h3>
                <div className="w-5 h-5 flex items-center justify-center shrink-0">
                  <i className="ri-arrow-down-s-line text-lg text-foreground-500 group-open:rotate-180 transition-transform"></i>
                </div>
              </summary>
              <div className="px-6 pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </details>
          ))}
        </div>

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": faqData.map((faq) => ({
              "@type": "Question",
              "name": faq.question,
              "acceptedAnswer": {
                "@type": "Answer",
                "text": faq.answer,
              },
            })),
          })}
        </script>
      </div>
    </section>
  );
}